import { inject, Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { ChoiceListElementStore } from '../stores/choice-list-element.store';
import { ChoiceListStore } from '../stores/choice-list.store';

@Injectable({
  providedIn: 'root',
})
export class ChoiceListsResolver implements Resolve<void> {
  private readonly choiceListStore = inject(ChoiceListStore);
  private readonly choiceListElementStore = inject(ChoiceListElementStore);

  async resolve(): Promise<void> {
    await this.choiceListStore.loadAll();
    await this.choiceListElementStore.loadAll();

    return Promise.resolve();
  }
}
